import React, { useEffect, useState } from 'react';
import { Form, Modal } from 'antd';
import { isArray } from '@lhb/func';
import { getTemplateLists } from '@/common/api/expandStore/chancepoint';
import V2Form from '@/common/components/Form/V2Form';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import { useMethods } from '@lhb/hook';

/**
 * 选择机会点模板的弹窗
 * @Description 从机会点列表迁移出来的
 * 目前使用场景：机会点列表/客流计数详情
 */
const SelectChancePointTemplate: React.FC<{
  open,
  chancepointAlias,
  setVisible,
  setFormDrawerData,
  setTemplateData,
}> = ({
  open,
  chancepointAlias,
  setVisible,
  setFormDrawerData,
  setTemplateData,
}) => {

  /** 真正控制弹窗显示 */
  const [curVisible, setCurVisible] = useState(false);

  const [form] = Form.useForm();
  const [options, setOptions] = useState<any>([]);

  const loadOptions = async () => {
    const result: any = await getTemplateLists();
    if (isArray(result) && result.length) {
      const options = result.map((item) => ({ label: item.templateName, value: item.id }));
      setOptions(options);
      setTemplateData && setTemplateData({
        isLoaded: true,
        data: options,
      });
    }
  };

  // 外面用到
  useEffect(() => {
    loadOptions();
  }, []);

  useEffect(() => {
    if (open) {
      methods.init();
    } else {
      setCurVisible(false);
    }
  }, [open]);

  const onCancel = () => {
    setVisible(false);
  };

  const onSubmit = () => {
    form.validateFields().then((values: any) => {
      console.log('values4', values);
      setFormDrawerData({
        ...values,
        open: true,
      });
      onCancel();
    });
  };

  const methods = useMethods({

    init() {
      if (!Array.isArray(options)) {
        return;
      }
      // 如果只有一条数据，直接选中，否则展示弹窗
      if (options.length === 1) {
        methods.handleAutoSelectSingleItem();
      } else if (options.length > 1) {
        setCurVisible(true);
      }
    },

    /** 自动选择单条数据 */
    handleAutoSelectSingleItem() {
      if (Array.isArray(options) && options.length === 1) {
        setFormDrawerData({ templateId: options[0].value, open: true, });
        onCancel();
      }
    },

  });

  return (
    <Modal
      title={`选择${chancepointAlias}模板`}
      open={curVisible}
      width={336}
      onOk={onSubmit}
      onCancel={onCancel}
    >
      <V2Form form={form}>
        <V2FormSelect
          label='选择模板'
          name='templateId'
          placeholder='请选择模板'
          rules={[{ required: true, message: '请选择模板' }]}
          options={options}
        />
      </V2Form>
    </Modal>
  );
};

export default SelectChancePointTemplate;
